import React from 'react'

/**
 * Scraper response (2026-10-06): the API refuses a second home-address change
 * within 7 days with HTTP 429 and
 *   { message, code: 'LOCATION_CHANGE_LIMIT', data: { contact: { email, linkText } } }.
 * The profile save error shows that message with `linkText` as a mailto link.
 */
export const LOCATION_CHANGE_LIMIT_CODE = 'LOCATION_CHANGE_LIMIT'

const DEFAULT_EMAIL = 'help@tempstars.com'
const DEFAULT_LINK_TEXT = 'contact our membership success team'
const DEFAULT_MESSAGE = "There was a problem changing your address, please contact our membership success team and we'll be happy to help!"
const SIMPLE_EMAIL = /^[^\s@<>"']+@[^\s@<>"']+\.[^\s@<>"']+$/

export type ContactLinkMessage = {
    message: string
    email: string
    linkText: string
}

const readBody = (error: unknown): any => {
    const candidate = error as { body?: unknown; message?: unknown } | null | undefined
    if (candidate?.body && typeof candidate.body === 'object') return candidate.body
    if (typeof candidate?.message !== 'string') return null
    try {
        return JSON.parse(candidate.message)
    } catch {
        return null
    }
}

/** Returns the message and contact link when `error` is the address-change limit, else null. */
export function getAddressChangeLimit(error: unknown): ContactLinkMessage | null {
    const body = readBody(error)
    if (body?.code !== LOCATION_CHANGE_LIMIT_CODE) return null
    const contact = body?.data?.contact || {}
    return {
        message: typeof body.message === 'string' && body.message ? body.message : DEFAULT_MESSAGE,
        email: typeof contact.email === 'string' && SIMPLE_EMAIL.test(contact.email) ? contact.email : DEFAULT_EMAIL,
        linkText: typeof contact.linkText === 'string' && contact.linkText ? contact.linkText : DEFAULT_LINK_TEXT,
    }
}

/** `message` with its `linkText` phrase linked to `mailto:email` (the email is appended if the phrase is missing). */
export const ContactLinkText = ({ message, email, linkText }: ContactLinkMessage) => {
    const index = message.indexOf(linkText)
    if (index < 0) {
        return <>{message} <a href={`mailto:${email}`}>{email}</a></>
    }
    return (
        <>
            {message.slice(0, index)}
            <a href={`mailto:${email}`}>{linkText}</a>
            {message.slice(index + linkText.length)}
        </>
    )
}
